import type { FaireProductEntity } from "../../entity_types/product";

export const p_g65cs9ppum: FaireProductEntity = {
  token: "p_g65cs9ppum",
  type: "product",
  name: "Under the Palms Soy Wax Jar Candle, 5.6oz",
  brandToken: "b_ec3bkdsy",
  brandName: "8 Oak Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/9b26c3dd34644cd661329e025ae558ee24624fad43dc09ac1d285f7658f3b2fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e03996469976b1160401b53bbc36efe794520ef97f90954e0eff930509a10967.jpeg",
    "https://cdn.faire.com/fastly/f79449f434416126c4fe801de4a672086e34d0556d0d9318b01429b6dbda9276.jpeg",
    "https://cdn.faire.com/fastly/08e6b142b6cfddaa0c2cfa14bfc5eb0a08493da0c347f469dc3dccf5da6ac5d7.jpeg",
  ],
  priceDollars: 10,
  description:
    '5.6oz soy wax jar candle in the Under the Palms scent and print, made for home fragrance and gift shop retailers stocking jar candles for tropical-themed assortments.\n\nPoured in clean-burning soy wax, this candle delivers a steady, even burn that fills a room with fragrance from first light to last. The scent blends zesty grapefruit and bergamot with fresh green leaves, cooling mint, and warm amber for a bright, energizing aroma, while the box is printed with a vibrant banana leaf and palm design in green and pink. Compact and giftable, it\'s sized for a nightstand, bathroom counter, or entryway table where a smaller candle format sells well. Its smaller format also makes it an easy add-on sale alongside the 3-wick candle or reed diffuser from the same collection.\n\nMaterial: Made from soy wax.\nScent: Grapefruit, bergamot, green leaves, mint, and amber.\nDimensions: Measures 4" x 3" x 3".\nDesign: Packaged in a giftable box printed with the Under the Palms banana leaf and palm print in green and pink.\nUse case: Suited for everyday home fragrance, small-space styling, and gifting.\nRetailer fit: A fit for home fragrance retailers, gift shops, and candle boutiques building out an Under the Palms collection. Pairs with the matching room spray, reed diffuser, and lotion for a coordinated set.\nGifting: Works well as a hostess gift, birthday gift, or gift for anyone who loves tropical-inspired home fragrance.',
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:10.296Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
